import type { ReactNode } from 'react';
import { useEffect } from 'react';
import '../publicPages.css';

type Props = {
  /** Путь текущей страницы — для подсветки пункта меню. */
  path: '/download' | '/info';
  title: string;
  children: ReactNode;
};

/**
 * Общий каркас публичных страниц (/download, /info): шапка с брендом, навигация и подвал.
 * Оформление — на токенах theme.css, поэтому страницы совпадают по стилю с приложением
 * и переключаются вместе с темой (initTheme в main.tsx).
 */
export default function PublicPageLayout({ path, title, children }: Props) {
  useEffect(() => {
    document.title = `${title} — HomeChat`;
  }, [title]);

  return (
    <div className="public-page">
      <header className="public-topbar public-shell">
        <a className="public-brand" href="/">
          <img src="/pwa-192.png" alt="" width={30} height={30} />
          HomeChat
        </a>
        <nav className="public-nav" aria-label="Разделы сайта">
          <a href="/download" aria-current={path === '/download' ? 'page' : undefined}>Скачать</a>
          <a href="/info" aria-current={path === '/info' ? 'page' : undefined}>О проекте</a>
          <a href="/">Открыть мессенджер</a>
        </nav>
      </header>
      <main className="public-main public-shell">{children}</main>
      <footer className="public-footer public-shell">
        <span>HomeChat — мессенджер для себя и друзей</span>
        <a href="/download">Скачать</a>
        <a href="/info">О проекте</a>
      </footer>
    </div>
  );
}
